import React from "react";
import Page from "components/Page";
import Home from "pages/Home";
import AlterarEmail from "pages/AlterarEmail";
import AlterarSenha from "pages/ChangePassword";
import Privacidade from "pages/Privacidade";
import GerenciarNumeros from "pages/GerenciarNumeros";
import Dependentes from "pages/Dependentes";
import { StateProvider } from "./store.js";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import "./App.scss";
import UserInfo from "components/UserInfo";
import PublicPage from "./components/Page/PublicPage.js";
import Customer2Fa from "./pages/Customer2Fa/Customer2Fa.js";

const RouteAwareRedirect = (props) => (
  <Route
    render={(routeProps) => {
      return <Redirect {...props} to={props.to + props.location.search} />;
    }}
  />
);

function App() {
  return (
    <>
      <StateProvider>
        <Router>
          <Switch>
            <Route
                exact
                path="/meuperfil/customer2fa"
                render={(params) => {
                  return (
                    <PublicPage>
                      <Customer2Fa />
                    </PublicPage>
                  );
                }}
              />
            <Route
              exact
              path="/meuperfil"
              render={(params) => {
                return (
                  <Page>
                    <Home />
                  </Page>
                );
              }}
            />
            <Route
              exact
              path="/meuperfil/alterar-email"
              render={(params) => {
                return (
                  <Page>
                    <AlterarEmail key={params.history.location.key} />
                  </Page>
                );
              }}
            />
            {/* <Route
              exact
              path="/meuperfil/meus-numeros"
              render={(params) => {
                return (
                  <Page>
                    <Dependentes key={params.history.location.key} />
                  </Page>
                );
              }}
            /> */}
            <Route
              exact
              path="/meuperfil/acesso-pelo-celular"
              render={(params) => {
                return (
                  <Page>
                    <GerenciarNumeros key={params.history.location.key} />
                  </Page>
                );
              }}
            />
            <RouteAwareRedirect
              from="/meuperfil/gerenciar-acesso-celular"
              to="/meuperfil/acesso-pelo-celular"
            />
            <RouteAwareRedirect from="*" to="/meuperfil" />
          </Switch>
        </Router>
      </StateProvider>
    </>
  );
}

export default App;
